<template>
  <MainLayout :currentLang="currentLang" :contactTxt="$t('message.contactTxt')" :contactMobileTxt="$t('message.contactTxtMobile')">
    <el-carousel :interval="5000" :autoplay="false" :indicator-position="'none'">
      <el-carousel-item>
        <!-- banner -->
        <section class="banner-section home">
          <div class="banner-content w-page fly-in">
            <div class="text">
              <p v-html="$t('message.index.banner.title')"></p>
            </div>
            <div class="text2" v-if="currentLang == 'cn'">
              <p v-html="$t('message.index.banner.content')"></p>
              <p>
                <SingleCycleDisplay class="cycleDisplayCn" :texts="textData" :buttons="[]" :duration="1500" />
              </p>
            </div>
            <div class="text2" v-if="currentLang == 'en'">
              <p v-html="$t('message.index.banner.content')"></p>
            </div>
            <div class="text2 en" v-if="currentLang == 'en'">
              <SingleCycleDisplay class="cycleDisplay" :texts="textData" :buttons="[]" :duration="1500" />
            </div>
            <!-- <div class="desc" v-html="$t('message.index.banner.desc')"></div> -->
            <span class="toUseBtn click-enter" @click="jumpRoute('/login')">
              <!-- 申请体验 -->
              {{ $t('message.index.banner.btnText') }}
              <i class="el-icon-arrow-right"></i>
            </span>
          </div>
        </section>
      </el-carousel-item>

      <el-carousel-item>
        <!-- banner -->
        <section class="bottom-banner">
          <div class="img-box">
            <img class="w-100" src="@/assets/images/home/banner-robot.jpg" alt="" />
          </div>
          <div class="text-box">
            <h4>
              Autonomous Agent
            </h4>
            <h3>
              <span>
                7x24 小时
              </span>
              <br />
              全自动销售与售前服务
            </h3>
            <div class="text-main">
              <span>
                · 自主搜寻/分析客户
              </span>
              <span>
                · 业务知识问答
              </span>
              <span>
                · 自主市场分析
              </span>
              <span>
                · 个性化邮件沟通
              </span>
              <span>
                · 客户情报洞察
              </span>
              <span>
                · 挖掘客户痛点
              </span>
              <span>
                · 方案生成
              </span>
              <span>
                · 资料翻译
              </span>
            </div>
            <span class="toUseBtn click-enter" @click="jumpRoute('/login')">
              了解更多
              <i class="el-icon-arrow-right"></i>
            </span>
          </div>
        </section>
      </el-carousel-item>
    </el-carousel>

    <!-- 我们能解决什么问题 -->
    <section class="w-page section problem-section">
      <div class="section-title">
        <h2>{{ $t('message.index.text32') }}</h2>
      </div>

      <div class="problem-content" :class="currentLang == 'en' ? 'en' : ''">
        <div class="problem-wrap mb-3 d-flex">
          <div class="problem-item first">
            <h2 class="text-center">
              {{ $t('message.index.text33') }}
              <img class="underline" src="@/assets/images/home/underline.png" alt="" />
            </h2>
          </div>
          <div class="problem-item last">
            <h2 class="text-center">
              {{ $t('message.index.text34') }}
              <img class="underline" src="@/assets/images/home/underline.png" alt="" />
            </h2>
          </div>
        </div>
        <div class="problem-main">
          <div class="problem-img">
            <div class="problem-left problem-img-item">
              <div class="problem-left-item" v-for="item in linkData.slice(0, 9)" :key="item.label" @click="jumpRoute(item.url)">
                {{ item.label }}
              </div>
              <div class="problem-left-item">
                ......
              </div>
            </div>
            <div class="link tool-link" @click="jumpRoute('/tools')">AI工具</div>
            <div class="link robot-link" @click="jumpRoute('/Robot')">机器人员工</div>
            <img src="@/assets/images/home/banner-problem.png" alt="" />
            <div class="problem-right problem-img-item">
              <div class="problem-right-item" v-for="item in linkData.slice(9, 18)" :key="item.label" @click="jumpRoute(item.url)">
                {{ item.label }}
              </div>
              <div class="problem-right-item">
                ......
              </div>
            </div>
            <div class="link service-link" @click="jumpRoute('/services')" v-html="'代运营服务'"></div>
          </div>
        </div>
      </div>
    </section>

    <!-- 业务环节 -->
    <section class="w-page section business-section">
      <div class="section-title">
        <h2>{{ $t('message.index.text35') }}</h2>
      </div>

      <div class="business-content" :class="currentLang == 'en' ? 'en' : ''">
        <div class="business-row">
          <div class="business-col1">
            <div class="dark-btn">
              {{ $t('message.index.text33') }}
            </div>
          </div>
          <div class="business-col3">
            <div class="dark-btn">
              {{ $t('message.index.text34') }}
            </div>
          </div>
        </div>
        <div class="business-row">
          <div class="business-item w-50 d-flex">
            <div class="business-col">
              <div class="success-btn toUseBtn click-enter">
                {{ $t('message.index.text36') }}
              </div>
              <div class="success-btn toUseBtn click-enter">
                {{ $t('message.index.text37') }}
              </div>
            </div>
            <div class="business-col">
              <div class="success-btn toUseBtn click-enter">
                {{ $t('message.index.text38') }}
              </div>
              <div class="success-btn toUseBtn click-enter">
                {{ $t('message.index.text39') }}
              </div>
            </div>
            <div class="business-col">
              <div class="success-btn toUseBtn click-enter">
                {{ $t('message.index.text40') }}
              </div>
              <div class="success-btn toUseBtn click-enter">
                {{ $t('message.index.text41') }}
              </div>
            </div>
          </div>
          <div class="business-item w-50 d-flex">
            <div class="business-col">
              <div class="toUseBtn click-enter">
                {{ $t('message.index.text42') }}
              </div>
              <div class="toUseBtn click-enter mobile-special">
                {{ $t('message.index.text43') }}
              </div>
            </div>
            <div class="business-col">
              <div class="toUseBtn click-enter special" v-html="$t('message.index.text44')"></div>
              <div class="toUseBtn click-enter">
                {{ $t('message.index.text45') }}
              </div>
            </div>
            <div class="business-col">
              <div class="toUseBtn click-enter special" v-html="$t('message.index.text46')"></div>
              <div class="toUseBtn click-enter">
                {{ $t('message.index.text47') }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="rate">
        <h3>
          {{ $t('message.index.text48') }}
        </h3>
        <div class="rate-content">
          <div class="step1">
            {{ $t('message.index.text49') }}
          </div>
          <div class="step2">
            {{ $t('message.index.text50') }}
          </div>
        </div>
      </div>
    </section>

    <!-- 工具 -->
    <section class="w-page section tool-section">
      <div class="section-title">
        <h2>{{ $t('message.index.tool.title') }}</h2>
      </div>

      <div class="tool-content">
        <div class="tool-item1 cursor-pointer" @click="jumpRoute('/tools')">
          <img class="scale-img w-100 h-100" src="@/assets/images/home/tool1.jpg" alt="" />
          <h3>
            {{ $t('message.index.tool.content[0].title') }}
            <img class="underline" src="@/assets/images/home/tool-underline1.png" alt="" />
          </h3>
          <div class="tool-desc">
            <div v-html="$t('message.index.tool.content[0].desc')"></div>
            <div class="icon-wrap">
              <img src="@/assets/images/home/tool-icon.png" alt="" />
            </div>
          </div>
        </div>
        <div class="tool-item1 cursor-pointer" @click="jumpRoute('/Robot')">
          <img class="scale-img w-100 h-100" src="@/assets/images/home/tool-robot.png" alt="" />
          <h3>
            机器人员工
            <img class="underline" src="@/assets/images/home/tool-underline1.png" alt="" />
          </h3>
          <div class="tool-desc">
            <div v-html="'若您希望 7×24 小时全自动拓客，<br/>我们可提供全链路智能机器人员工'"></div>
            <div class="icon-wrap">
              <img src="@/assets/images/home/tool-icon.png" alt="" />
            </div>
          </div>
        </div>
        <div class="tool-item2 cursor-pointer" @click="jumpRoute('/services')">
          <img class="scale-img w-100 h-100" src="@/assets/images/home/tool2.jpg" alt="" />
          <h3>
            代运营服务
            <img class="underline" src="@/assets/images/home/tool-underline2.png" alt="" />
          </h3>
          <div class="tool-desc">
            <div v-html="$t('message.index.tool.content[1].desc')"></div>
            <div class="icon-wrap">
              <img src="@/assets/images/home/tool-icon.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="w-page section valuation-section">
      <div class="section-title">
        <h2>{{ $t('message.index.valuations.title') }}</h2>
      </div>

      <div class="valuation-container">
        <div class="valuation-content">
          <div class="left-col">
            <vue-seamless-scroll :data="firstListData.concat(firstListData)" :class-option="{ step: 0.5, direction: 2 }">
              <div class="valuation-list h-100">
                <div class="valuation-item" v-for="(item, index) in firstListData" :key="index">
                  <div class="user-wrap">
                    <div class="avatar">
                      <img :src="item.avatar" alt="" />
                    </div>
                    <div class="user-info">
                      <div class="user-name">
                        {{ item.name }}
                      </div>
                      <div class="user-industry">
                        {{ item.industry }}
                      </div>
                    </div>
                  </div>
                  <div class="top-content">
                    {{ item.content }}
                  </div>
                </div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
      </div>

      <div class="stats-grid w-page2" ref="myElement">
        <template v-if="isVisible">
          <div class="stat-item" v-for="(item, index) in dataList" :key="index">
            <div class="stat-number">
              <span class="stat-unit mr-1">></span>
              <countTo :startVal="0" :endVal="item.value" :duration="3000"></countTo>
              <span class="stat-unit ml-1">{{ item.unit }}</span>
            </div>
            <div class="stat-label">{{ item.label }}</div>
          </div>
        </template>
      </div>
    </div>

    <!-- 平台 -->
    <section class="w-page section platform-section" v-if="false">
      <el-row type="flex" align="center" class="platform-item" v-for="(item, index) in platformList" :key="index">
        <el-col :span="12" class="image">
          <div class="hvr-grow" v-if="!item.isPlay">
            <img :src="item.posterUrl" alt="" class="grow-img" />
            <div class="ovrly"></div>
            <div class="buttons" @click="playVideo(item)">
              <img src="@/assets/images/play.png" alt="" />
            </div>
          </div>
          <video v-else controls autoplay width="100%" height="100%" :poster="item.posterUrl">
            <source :src="item.videoUrl" type="video/mp4" />
            Your browser does not support the video element.
          </video>
        </el-col>
        <el-col :span="12" class="d-flex flex-column justify-content-center">
          <div class="platform-content">
            <h2 class="content-title" v-html="item.content.title"></h2>
            <div v-for="(childItem, childIndex) in item.content.info" class="content-info" :key="childIndex">
              <div class="d-flex align-items-start" :key="childIndex">
                <img :src="childItem.iconUrl" alt="" class="mr-2 content-icon" />
                <div>
                  <h4 class="content-title" v-html="childItem.title"></h4>
                  <p class="desc" v-html="childItem.desc"></p>
                </div>
              </div>
            </div>
            <span class="toUseBtn click-enter" @click="toVisualBudgetCenter">
              <!-- 立即体验 -->
              {{ $t('message.experienceBtn') }}
              <i class="el-icon-arrow-right"></i>
            </span>
          </div>
        </el-col>
      </el-row>
    </section>

    <!-- 核心功能价值 -->
    <section class="w-page section values-section" :class="currentLang == 'en' ? 'en' : ''" v-if="false">
      <div class="section-title">
        <h2>{{ $t('message.index.values.title') }}</h2>

        <span class="toUseBtn click-enter" @click="jumpRoute('/contact')">
          <!-- 申请体验 -->
          {{ $t('message.supportTools.banner.btnText') }}
          <i class="el-icon-arrow-right"></i>
        </span>
      </div>

      <el-row :gutter="36" justify="space-between">
        <el-col :span="6" v-for="(item, index) in valuesList" :key="index">
          <div class="values-item">
            <img :src="item.iconUrl" alt="" />
            <h4 v-html="item.title" class="mt-3 mb-2"></h4>
            <p v-html="item.desc"></p>
          </div>
        </el-col>
      </el-row>
    </section>
  </MainLayout>
</template>

<script>
import MainLayout from '../components/MainLayout.vue';
import SingleCycleDisplay from '../components/CycleDisplay.vue';
import vueSeamlessScroll from 'vue-seamless-scroll';
import countTo from 'vue-count-to';

export default {
  name: 'Home',
  props: ['currentLang'],
  inject: ['toVisualBudgetCenter'],
  components: {
    MainLayout,
    SingleCycleDisplay,
    vueSeamlessScroll,
    countTo,
  },
  data() {
    return {
      dataList: [
        {
          value: 50,
          unit: '%',
          label: this.$t('message.about.data.list[0].label'), // 销售成本降低
        },
        {
          value: 300,
          unit: '%',
          label: this.$t('message.about.data.list[1].label'), // 客户开拓效率提升
        },
        {
          value: 50,
          unit: '%',
          label: this.$t('message.about.data.list[2].label'), // 客户成功率提升
        },
        {
          value: 30,
          unit: '%',
          label: this.$t('message.about.data.list[3].label'), // 销售周期缩短
        },
      ],
      textDataCn: ['市场分析、全球获客', '痛点方案、智能辅助', '沟通策略、智能指导', '产品Demo智能“秀”“控”'],
      textData: [
        this.$t('message.index.text14'),
        this.$t('message.index.text15'),
        this.$t('message.index.text16'),
        this.$t('message.index.text17'),
        this.$t('message.index.text18'),
        this.$t('message.index.text19'),
        this.$t('message.index.text20'),
        this.$t('message.index.text21'),
        this.$t('message.index.text22'),
        this.$t('message.index.text31'),
        this.$t('message.index.text23'),
        this.$t('message.index.text24'),
        this.$t('message.index.text25'),
        this.$t('message.index.text26'),
        this.$t('message.index.text27'),
        this.$t('message.index.text28'),
        this.$t('message.index.text29'),
        this.$t('message.index.text30'),
      ],
      linkData: [
        {
          label: this.$t('message.index.text14'),
          url: '/problem-overseas-market',
        },
        {
          label: this.$t('message.index.text15'),
          url: '/problem-overseas-inspection',
        },
        {
          label: this.$t('message.index.text16'),
          url: '/problem-target-customer',
        },
        {
          label: this.$t('message.index.text17'),
          url: '/problem-low-cost',
        },
        {
          label: this.$t('message.index.text18'),
          url: '/problem-domestic-team',
        },
        {
          label: this.$t('message.index.text19'),
          url: '/problem-customer-respond',
        },
        {
          label: this.$t('message.index.text20'),
          url: '/problem-customer-contact',
        },
        {
          label: this.$t('message.index.text21'),
          url: '/problem-communicate',
        },
        {
          label: this.$t('message.index.text22'),
          url: '/problem-customer-inform',
        },
        {
          label: this.$t('message.index.text31'),
          url: '/problem-unclear-demand',
        },
        {
          label: this.$t('message.index.text23'),
          url: '/problem-business-mastery',
        },
        {
          label: this.$t('message.index.text24'),
          url: '/problem-major-impression',
        },
        {
          label: this.$t('message.index.text25'),
          url: '/problem-challenge-respond',
        },
        {
          label: this.$t('message.index.text26'),
          url: '/problem-efficient-response',
        },
        {
          label: this.$t('message.index.text27'),
          url: '/problem-travel-expenses',
        },
        {
          label: this.$t('message.index.text28'),
          url: '/problem-demonstrate-cost',
        },
        {
          label: this.$t('message.index.text29'),
          url: '/problem-business-promote',
        },
        {
          label: this.$t('message.index.text30'),
          url: '/problem-opponent-impact',
        },
      ],
      platformList: [
        {
          posterUrl: require('@/assets/images/home/platform1.png'),
          videoUrl: '/video/movie.mp4',
          isPlay: false,
          content: {
            title: this.$t('message.index.platform.list[0].content.title'),
            info: [
              {
                iconUrl: require('@/assets/images/home/platform-icon1.png'),
                title: this.$t('message.index.platform.list[0].content.info[0].title'),
                desc: this.$t('message.index.platform.list[0].content.info[0].desc'),
              },
              {
                iconUrl: require('@/assets/images/home/platform-icon2.png'),
                title: this.$t('message.index.platform.list[0].content.info[1].title'),
                desc: this.$t('message.index.platform.list[0].content.info[1].desc'),
              },
              {
                iconUrl: require('@/assets/images/home/platform-icon3.png'),
                title: this.$t('message.index.platform.list[0].content.info[2].title'),
                desc: this.$t('message.index.platform.list[0].content.info[2].desc'),
              },
              {
                iconUrl: require('@/assets/images/home/platform-icon4.png'),
                title: this.$t('message.index.platform.list[0].content.info[3].title'),
                desc: this.$t('message.index.platform.list[0].content.info[3].desc'),
              },
            ],
          },
        },
        {
          posterUrl: require('@/assets/images/home/platform2.png'),
          videoUrl: '/video/movie.mp4',
          isPlay: false,
          content: {
            title: this.$t('message.index.platform.list[1].content.title'),
            info: [
              {
                iconUrl: require('@/assets/images/home/platform-icon1.png'),
                title: this.$t('message.index.platform.list[1].content.info[0].title'),
                desc: this.$t('message.index.platform.list[1].content.info[0].desc'),
              },
              {
                iconUrl: require('@/assets/images/home/platform-icon2.png'),
                title: this.$t('message.index.platform.list[1].content.info[1].title'),
                desc: this.$t('message.index.platform.list[1].content.info[1].desc'),
              },
              {
                iconUrl: require('@/assets/images/home/platform-icon3.png'),
                title: this.$t('message.index.platform.list[1].content.info[2].title'),
                desc: this.$t('message.index.platform.list[1].content.info[2].desc'),
              },
              {
                iconUrl: require('@/assets/images/home/platform-icon4.png'),
                title: this.$t('message.index.platform.list[1].content.info[3].title'),
                desc: this.$t('message.index.platform.list[1].content.info[3].desc'),
              },
              {
                iconUrl: require('@/assets/images/home/platform-icon4.png'),
                title: this.$t('message.index.platform.list[1].content.info[4].title'),
                desc: this.$t('message.index.platform.list[1].content.info[4].desc'),
              },
              {
                iconUrl: require('@/assets/images/home/platform-icon4.png'),
                title: this.$t('message.index.platform.list[1].content.info[5].title'),
                desc: this.$t('message.index.platform.list[1].content.info[5].desc'),
              },
            ],
          },
        },
        {
          posterUrl: require('@/assets/images/home/platform3.png'),
          videoUrl: '/video/movie.mp4',
          isPlay: false,
          content: {
            title: this.$t('message.index.platform.list[2].content.title'),
            info: [
              {
                iconUrl: require('@/assets/images/home/platform-icon4.png'),
                title: this.$t('message.index.platform.list[2].content.info[0].title'),
                desc: this.$t('message.index.platform.list[2].content.info[0].desc'),
              },
              {
                iconUrl: require('@/assets/images/home/platform-icon1.png'),
                title: this.$t('message.index.platform.list[2].content.info[1].title'),
                desc: this.$t('message.index.platform.list[2].content.info[1].desc'),
              },
              {
                iconUrl: require('@/assets/images/home/platform-icon2.png'),
                title: this.$t('message.index.platform.list[2].content.info[2].title'),
                desc: this.$t('message.index.platform.list[2].content.info[2].desc'),
              },
              {
                iconUrl: require('@/assets/images/home/platform-icon3.png'),
                title: this.$t('message.index.platform.list[2].content.info[3].title'),
                desc: this.$t('message.index.platform.list[2].content.info[3].desc'),
              },
            ],
          },
        },
      ],
      valuesList: [
        {
          iconUrl: require('@/assets/images/home/values-icon2.png'),
          title: this.$t('message.index.values.list[0].title'),
          desc: this.$t('message.index.values.list[0].desc'),
        },
        {
          iconUrl: require('@/assets/images/home/values-icon3.png'),
          title: this.$t('message.index.values.list[1].title'),
          desc: this.$t('message.index.values.list[1].desc'),
        },
        {
          iconUrl: require('@/assets/images/home/values-icon4.png'),
          title: this.$t('message.index.values.list[2].title'),
          desc: this.$t('message.index.values.list[2].desc'),
        },
        {
          iconUrl: require('@/assets/images/home/values-icon5.png'),
          title: this.$t('message.index.values.list[3].title'),
          desc: this.$t('message.index.values.list[3].desc'),
        },
        // {
        //   iconUrl: require('@/assets/images/home/values-icon5.png'),
        //   title: this.$t('message.index.values.list[4].title'),
        //   desc: this.$t('message.index.values.list[4].desc'),
        // },
        // {
        //   iconUrl: require('@/assets/images/home/values-icon6.png'),
        //   title: this.$t('message.index.values.list[5].title'),
        //   desc: this.$t('message.index.values.list[5].desc'),
        // },
      ],

      firstListData: [
        {
          content: this.$t('message.index.valuations.msg1'),
          avatar: require('@/assets/images/home/avatar2.png'),
          name: '关女士',
          industry: '国际物流方案集成商',
        },
        {
          content: this.$t('message.index.valuations.msg6'),
          avatar: require('@/assets/images/home/avatar7.png'),
          name: '王先生',
          industry: '工业软件开发商',
        },
        {
          content: this.$t('message.index.valuations.msg5'),
          avatar: require('@/assets/images/home/avatar8.png'),
          name: '钱先生',
          industry: '跨境ERP系统开发商',
        },
        {
          content: this.$t('message.index.valuations.msg4'),
          avatar: require('@/assets/images/home/avatar4.png'),
          name: '汪先生',
          industry: '跨境自动化技术输出商',
        },
      ],
      secondListData: [
        {
          content: this.$t('message.index.valuations.msg4'),
          avatar: require('@/assets/images/home/avatar4.png'),
          name: this.$t('message.index.valuations.msg13'),
          industry: this.$t('message.index.valuations.msg21'),
        },
        {
          content: this.$t('message.index.valuations.msg5'),
          avatar: require('@/assets/images/home/avatar8.png'),
          name: this.$t('message.index.valuations.msg14'),
          industry: this.$t('message.index.valuations.msg22'),
        },
        {
          content: "I started using Xpirory and was amazed. This is the feeling that business development should have. I can't work without Xpirory now.",
          avatar: require('@/assets/images/home/avatar11.png'),
          name: 'Mr.Tey',
          industry: 'Precision Component Supplier',
        },
      ],
      thirdListData: [
        {
          content: this.$t('message.index.valuations.msg1'),
          avatar: require('@/assets/images/home/avatar2.png'),
          name: this.$t('message.index.valuations.msg15'),
          industry: this.$t('message.index.valuations.msg23'),
        },
        {
          content: this.$t('message.index.valuations.msg6'),
          avatar: require('@/assets/images/home/avatar7.png'),
          name: this.$t('message.index.valuations.msg16'),
          industry: this.$t('message.index.valuations.msg24'),
        },
        {
          content:
            'Xpirory’s market analysis guided our Southeast Asia expansion strategy. Leveraging the platform’s solution generator, we quickly developed regional industrial robot solutions and targeted pre-identified prospects via email. Multiple inquiries followed—at a fraction of traditional costs.',
          avatar: require('@/assets/images/home/avatar12.png'),
          name: 'Miss.Rossi',
          industry: 'Industrial Robot Integrator',
        },
        {
          content: this.$t('message.index.valuations.msg7'),
          avatar: require('@/assets/images/home/avatar11.png'),
          name: this.$t('message.index.valuations.msg17'),
          industry: this.$t('message.index.valuations.msg25'),
        },
      ],
      fourthListData: [
        // {
        //   content: this.$t('message.index.valuations.msg1'),
        //   avatar: require('@/assets/images/home/avatar3.png'),
        //   name: this.$t('message.index.valuations.msg18'),
        //   industry: this.$t('message.index.valuations.msg25'),
        // },
        {
          content:
            "The supply chain graph helped us discover the transaction preferences of German customers. Through targeted email pushes, we effectively obtained the customers' contact information and initiated new cooperation! Xpirory is truly amazing!",
          avatar: require('@/assets/images/home/avatar6.png'),
          name: 'Mr.Bos',
          industry: 'Equipment Manufacturer',
        },
        {
          content: this.$t('message.index.valuations.msg8'),
          avatar: require('@/assets/images/home/avatar10.png'),
          name: this.$t('message.index.valuations.msg19'),
          industry: this.$t('message.index.valuations.msg26'),
        },
        {
          content: this.$t('message.index.valuations.msg9'),
          avatar: require('@/assets/images/supportTools/avatar2.png'),
          name: this.$t('message.index.valuations.msg17'),
          industry: this.$t('message.index.valuations.msg27'),
        },
      ],
      fifthListData: [
        {
          content: this.$t('message.index.valuations.msg1'),
          avatar: require('@/assets/images/home/avatar11.png'),
          name: 'Mr. Gery',
          industry: 'International logistics',
        },
        {
          content: this.$t('message.index.valuations.msg10'),
          avatar: require('@/assets/images/home/avatar5.png'),
          name: this.$t('message.index.valuations.msg17'),
          industry: this.$t('message.index.valuations.msg28'),
        },
        {
          content: this.$t('message.index.valuations.msg11'),
          avatar: require('@/assets/images/home/avatar9.png'),
          name: this.$t('message.index.valuations.msg20'),
          industry: this.$t('message.index.valuations.msg29'),
        },
        {
          content: this.$t('message.index.valuations.msg12'),
          avatar: require('@/assets/images/home/avatar7.png'),
          name: this.$t('message.index.valuations.msg17'),
          industry: this.$t('message.index.valuations.msg30'),
        },
      ],
      isVisible: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll(); // 初始化检查一次是否已经在视野内
    this.setRem();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    setRem() {
      // 当前页面屏幕分辨率相对于 1920宽的缩放比例，可根据自己需要修改
      const scale = document.documentElement.clientWidth / 1920;
      // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
      document.documentElement.style.fontSize = 16 * Math.min(scale, 2) + 'px';
    },
    handleScroll() {
      const element = this.$refs.myElement;
      const rect = element.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      if (rect.top < windowHeight && rect.bottom >= 0) {
        this.isVisible = true;
      } else {
        this.isVisible = false;
      }
    },
    // 播放
    playVideo(item) {
      item.isPlay = !item.isPlay;
    },
    jumpRoute(route) {
      if (route == '/login') {
        this.$router.push('/contact');
      } else {
        this.$router.push(route);
        window.scrollTo(0, 0);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep() {
  .el-carousel__container {
    height: 843px;
  }
}
.banner-section {
  background: url('@/assets/images/home/banner-cn.jpg') center center no-repeat;
  background-size: cover;
  height: 843px;
  // margin-bottom: 80px;
  color: #fff;

  ::v-deep() {
    .text2 {
      span {
        font-size: 36px;
        font-weight: 600;
        color: #1a64ff;
      }
    }
  }

  .banner-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    // width: 90%;

    .cycleDisplayCn {
      color: #1867ff;
      font-weight: 700;
      font-size: 36px;
    }

    .cycleDisplay {
      font-size: 36px;
      color: #1867ff;
      font-weight: 700;
    }

    .text {
      p {
        font-size: 58px;
        font-weight: 600;
        line-height: 1.5;
        margin: 0;
      }

      p:last-child {
        margin-bottom: 0;
      }
    }

    .text2 {
      margin-top: 50px;
      margin-bottom: 62px;
      p {
        font-size: 30px;
        margin: 0;
        margin-bottom: 14px;
      }

      p:last-child {
        margin-bottom: 0;
      }
    }

    .desc {
      font-size: 22px;
      color: rgba(255, 255, 255, 0.8);
      margin: 40px 0 50px;
    }
  }
}

.platform-section {
  .platform-item {
    .image {
      height: 645px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .platform-content {
      margin-left: 100px;

      h2.content-title {
        font-size: 40px;
        line-height: 1.3;
        margin-bottom: 15px;
      }

      .content-info {
        padding: 10px 0 0;

        .content-icon {
          margin-top: 10px;
        }

        h4.content-title {
          font-size: 22px;
          line-height: 1.4;
        }

        p.desc {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.7);
          padding-bottom: 5px;
          border-bottom: 1px solid #272727;
        }
      }

      .content-info:last-of-type {
        border-bottom: none;
      }

      .toUseBtn {
        margin-top: 20px;
        width: 220px;
      }
    }
  }

  .platform-item:nth-of-type(2n) {
    .image {
      order: 1;
    }
  }
}

.problem-section {
  .section-title {
    h2 {
      font-size: 44px;
      margin-bottom: 20px;
    }
  }
  .problem-content {
    .problem-wrap {
      .problem-item {
        width: 50%;
        text-align: center;
        position: relative;
        &.first {
          h2 {
            .underline {
              width: 200px;
            }
          }
        }
        &.last {
          h2 {
            .underline {
              width: 254px;
            }
          }
        }
        h2 {
          display: inline-block;
          font-size: 26px;
          .underline {
            position: absolute;
            height: 12px;
            left: 50%;
            bottom: -6px;
            transform: translateX(-50%);
            z-index: -1;
          }
          // &::after {
          //   content: '';
          //   position: absolute;
          //   background: #1a64ff;
          //   top: 0;
          //   left: -5px;
          //   bottom: 0;
          //   width: 1.4em;
          //   border-radius: 50%;
          //   z-index: -1;
          // }
        }
      }
    }

    .problem-main {
      display: flex;
      .problem-img {
        width: 100%;
        position: relative;
        text-align: center;
        img {
          width: 830px;
        }
        .problem-img-item {
          .problem-left-item,
          .problem-right-item {
            background: url('@/assets/images/home/bg-problem.png') no-repeat;
            background-size: cover;
            margin-bottom: 5px;
            cursor: pointer;
            &:hover {
              background: url('@/assets/images/home/activeBg-problem.png') no-repeat;
              background-size: cover;
            }
          }
        }
        .problem-left {
          position: absolute;
          left: 0;
          top: 5px;
          .problem-left-item {
            width: 528px;
            height: 62px;
            font-size: 20px;
            line-height: 62px;
            position: relative;
          }
          .problem-left-item:nth-child(1) {
            left: 126px;
          }
          .problem-left-item:nth-child(2) {
            left: 25px;
          }
          .problem-left-item:nth-child(3) {
            left: -26px;
          }
          .problem-left-item:nth-child(4) {
            left: -53px;
          }
          .problem-left-item:nth-child(5) {
            left: -63px;
          }
          .problem-left-item:nth-child(6) {
            left: -58px;
          }
          .problem-left-item:nth-child(7) {
            left: -37px;
          }
          .problem-left-item:nth-child(8) {
            left: 4px;
          }
          .problem-left-item:nth-child(9) {
            left: 78px;
          }
          .problem-left-item:last-child {
            left: 84px;
            background: none;
          }
        }
        .problem-right {
          position: absolute;
          right: 0;
          top: 5px;
          .problem-right-item {
            width: 528px;
            height: 62px;
            line-height: 62px;
            font-size: 20px;
            position: relative;
          }
          .problem-right-item:nth-child(1) {
            right: 105px;
          }
          .problem-right-item:nth-child(2) {
            right: 0;
          }
          .problem-right-item:nth-child(3) {
            right: -50px;
          }
          .problem-right-item:nth-child(4) {
            right: -77px;
          }
          .problem-right-item:nth-child(5) {
            right: -87px;
          }
          .problem-right-item:nth-child(6) {
            right: -82px;
          }
          .problem-right-item:nth-child(7) {
            right: -61px;
          }
          .problem-right-item:nth-child(8) {
            right: -19px;
          }
          .problem-right-item:nth-child(9) {
            right: 55px;
          }
          .problem-right-item:last-child {
            right: 65px;
            background: none;
          }
        }
        .link {
          position: absolute;
          width: 215px;
          height: 75px;
          border-radius: 35px;
          cursor: pointer;
          font-size: 28px;
          font-weight: 600;
          line-height: 1.3;
          display: flex;
          justify-content: center;
          align-items: center;
          &:hover {
            text-shadow: 2px 2px 4px #444;
            transition: 0.3s ease;
          }
        }
        .tool-link {
          top: 145px;
          left: 626px;
        }
        .robot-link {
          top: 272px;
          left: 626px;
        }
        .service-link {
          bottom: 165px;
          left: 626px;
        }
      }
    }
  }
}

.business-section {
  padding-top: 0;
  padding-left: 5rem;
  padding-right: 5rem;
  .section-title {
    h2 {
      font-size: 44px;
      margin-bottom: 20px;
    }
  }
  .business-content {
    .business-row:first-child {
      margin-bottom: 15px;
    }
    .business-row {
      display: flex;
      .dark-btn {
        text-align: center;
        background-color: #0c0c0c;
        color: #fff;
        border-radius: 4px;
        border: none;
        padding: 16px 0;
        font-size: 18px;
        box-shadow: 0 0 6px rgba(255, 255, 255, 0.8) inset;
        transition: background-color 0.3s ease;
        &:hover {
          box-shadow: 0 0 8px rgba(255, 255, 255, 0.9) inset; /* 内部阴影，增加按钮的立体感 */
        }
      }
      .success-btn {
        background-color: #0feb95;
      }
      .business-col1,
      .business-col2 {
        width: 50%;
      }
      .business-col3 {
        width: 50%;
        padding-left: 15px;
      }
      .business-col1 {
        padding-right: 15px;
      }
      .business-col2 {
        padding-left: 15px;
        padding-right: 15px;
      }

      .business-item {
        gap: 30px;
        .business-col {
          width: 33.33%;
          .toUseBtn {
            width: 100%;
            height: 47px;
            margin-bottom: 8px;
            &.success-btn {
              text-shadow: 2px 2px 4px #222;
            }
            &.special {
              line-height: 1.1;
              padding: 4px 0;
            }
          }
        }
      }
      .business-item:first-child {
        padding-right: 15px;
      }
      .business-item:last-child {
        padding-left: 15px;
      }
    }
  }
  .rate {
    h3 {
      font-size: 28px;
      text-align: center;
      margin: 25px 0 15px;
    }
    .rate-content {
      display: flex;
      background-color: #0c0c0c;
      color: #fff;
      border-radius: 24px;
      border: none;
      font-size: 18px;
      box-shadow: 0 0 6px rgba(255, 255, 255, 0.8) inset;
      transition: background-color 0.3s ease;
      .step1 {
        width: 18%;
        height: 100%;
        padding: 6px 0;
        text-align: center;
        background-color: #0feb95;
        border-radius: 24px;
        text-shadow: 2px 2px 4px #222;
      }
      .step2 {
        width: 82%;
        height: 100%;
        padding: 6px 0;
        text-align: center;
        background-color: #1a64ff;
        border-radius: 24px;
      }
    }
  }
}

.tool-section {
  padding-left: 7rem;
  padding-right: 7rem;
  .section-title {
    h2 {
      font-size: 44px;
      margin-bottom: 20px;
    }
  }
  .tool-content {
    display: flex;
    justify-content: space-between;
    gap: 35px;
    > div {
      width: 443px;
      // height: 485px;
      border-radius: 10px;
      overflow: hidden;
      .scale-img {
        transition: all 0.3s;
      }
      &:hover {
        .scale-img {
          scale: (1.1);
        }
      }
      h3 {
        position: absolute;
        top: 45px;
        left: 35px;
        font-size: 28px;
        text-shadow: -1px -1px 0 #000, 0px -1px 0 #000, 1px -1px 0 #000, -1px 0px 0 #000, 1px 0px 0 #000, -1px 1px 0 #000, 0px 1px 0 #000, 1px 1px 0 #000;
      }
    }
    .tool-item1 {
      position: relative;
      h3 {
        .underline {
          position: absolute;
          height: 12px;
          left: 0;
          bottom: -6px;
        }
      }
    }
    .tool-item2 {
      position: relative;
      h3 {
        .underline {
          position: absolute;
          height: 12px;
          left: 0;
          bottom: -6px;
        }
      }
      .icon-wrap:last-child {
        img {
          background: #0feb95;
        }
      }
    }
    .tool-desc {
      position: absolute;
      bottom: 20px;
      left: 10px;
      right: 10px;
      background: rgba(31, 44, 63, 0.8);
      border-radius: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 15px 10px 35px;
      box-sizing: border-box;
      div {
        font-size: 16px;
        line-height: 1.5;
      }
      .icon-wrap {
        //   width: 43px;
        // height: 43px;
        // text-align: center;
        // line-height: 43px;
        //   border-radius: 50%;
        img {
          background: #1a61f7;
          padding: 4px;
          border-radius: 50%;
          width: 40px;
        }
      }
    }
  }
}

.tool-section .tool-content .icon-wrap img {
  animation-name: move-left-to-right;
  animation-duration: 1s;
  animation-delay: 0.6s;
  animation-iteration-count: infinite;
  animation-direction: alternative;
}

.bottom-banner {
  position: relative;
  .text-box {
    position: absolute;
    top: 50%;
    left: 12.5%;
    transform: translateY(-50%);
    h4 {
      font-size: 36px;
    }
    h3 {
      font-size: 58px;
      font-weight: 500;
      line-height: 1.2;
      margin: 20px 0 30px;
      span {
        color: #1a64ff;
        font-weight: 600;
      }
    }
    .text-main {
      display: flex;
      flex-wrap: wrap;
      width: 580px;
      span {
        width: 50%;
        margin-bottom: 8px;
        font-size: 24px;
      }
    }
    .toUseBtn {
      margin-top: 35px;
    }
  }
}

@keyframes move-left-to-right {
  0% {
    transform: translateX(5%);
  }

  50% {
    transform: translateX(15%);
  }

  100% {
    transform: translateX(5%);
  }
}

.valuation-section {
  width: 100%;
  .section-title {
    h2 {
      font-size: 44px;
      margin-bottom: 20px;
    }
  }

  .valuation-container {
    // height: 800px;
    overflow: hidden;
    position: relative;
    .valuation-content {
      display: flex;
    }

    .left-col {
      width: 100%;
      .valuation-list {
        width: 100%;
        display: flex;
        .valuation-item {
          width: 25vw;
          margin-right: 20px;
        }
      }
    }
    .right-col {
      .valuation-list {
        width: 200%;
      }
    }
    .valuation-list {
      .valuation-item {
        padding: 15px 20px;
        padding-top: 30px;
        border: 1px solid #2f2f2f;
        border-radius: 8px;
        position: relative;
        .top-content {
          padding: 25px 0 20px;
          line-height: 2;
        }
        .user-wrap {
          display: flex;
          align-items: center;
          .avatar {
            margin-right: 10px;
            img {
              width: 52px;
            }
          }
        }
        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: url('@/assets/images/supportTools/hover-bg.png') center/cover;
          border-radius: 8px;
          opacity: 0;
          transition: opacity 0.4s ease;
          z-index: -1;
        }
        &:hover::after {
          opacity: 1;
        }
        & {
          margin-bottom: 25px;
        }
      }
    }
  }
  .valuation-content::before {
    content: '';
    position: absolute;
    right: 0;
    width: 12.5%;
    height: 100%;
    background-image: linear-gradient(to left, #000, rgb(255 255 255/0));
    z-index: 6;
  }
  .valuation-content::after {
    content: '';
    position: absolute;
    left: 0;
    width: 12.5%;
    height: 100%;
    background-image: linear-gradient(to right, #000, rgb(255 255 255/0));
    z-index: 6;
  }
  .top-shadow {
    position: absolute;
    top: 0;
    width: 100%;
    height: 288px;
    background-image: linear-gradient(to bottom, #000, rgb(255 255 255/0));
    pointer-events: none;
    z-index: 6;
  }
  .bottom-shadow {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 288px;
    background-image: linear-gradient(to top, #000, rgb(255 255 255/0));
    pointer-events: none;
    z-index: 6;
  }

  .stats-grid {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 30px 0;
    border-radius: 10px;

    .stat-item {
      text-align: center;
      flex: 1;
      min-width: 150px;
      padding: 0 15px;
      position: relative;
    }

    .stat-item::after {
      position: absolute;
      right: 0;
      content: '';
      display: block;
      width: 2px;
      height: 40%;
      background-color: #fff;
      top: 50%;
      transform: translate(0, -50%);
    }

    .stat-item:last-child::after {
      display: none;
    }

    .stat-number {
      font-size: 60px;
      font-weight: bold;
      color: white;
      margin-bottom: 5px;
    }

    .stat-unit {
      font-size: 24px;
    }

    .stat-label {
      font-size: 18px;
      color: rgba(255, 255, 255, 0.8);
    }
  }
}

.values-section {
  padding-left: 80px;
  padding-right: 80px;
  .section-title {
    h2 {
      font-size: 44px;
      margin-bottom: 20px;
    }
  }

  ::v-deep {
    .el-col-6 {
      padding-left: 8px !important;
      padding-right: 8px !important;
    }
  }

  .values-item {
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 5px;
    padding: 20px 30px 20px;
    margin-bottom: 36px;

    h4 {
      font-size: 24px;
    }

    p {
      font-size: 13px;
      color: rgba(255, 255, 255, 0.9);
      font-family: 'Alibaba-PuHuiTi-Light';
      font-weight: 100;
      height: 60px;
    }
  }
}

.en-container {
  .dark-btn.special {
    padding: 5.5px !important;
  }
  .business-section .business-content .business-row .business-item .business-col .toUseBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
  }
  .banner-section {
    background: url('@/assets/images/home/banner-en.jpg') center center no-repeat;
    background-size: cover;
    .banner-content {
      // width: 94%;
      padding-bottom: 50px;
      .text {
        margin-bottom: 90px;
        p {
          font-size: 44px;
          font-weight: 700;
          line-height: 1.5;
          ::v-deep {
            span {
              font-size: 52px;
            }
          }
        }
      }

      .text2 {
        margin: 0;
        margin-bottom: 18px;
      }

      .text2.en {
        width: 50%;
        margin-bottom: 45px;
        height: 120px;
      }

      .desc {
        font-size: 20px;
        margin: 40px 0 50px;
      }
    }
  }

  .values-section {
    .values-item {
      h4 {
        height: 58px;
      }

      // p {
      //   height: 56px;
      // }
    }
  }
}

@media only screen and (max-width: 768px) {
  body .main-layout .stats-grid .stat-number {
    font-size: 86px;
  }

  body .main-layout .stats-grid .stat-unit {
    font-size: 46px;
  }

  body .main-layout .stats-grid .stat-label {
    font-size: 50px;
  }

  body .en-container .main-layout .banner-section .banner-content .text2.en {
    width: 100%;
    height: 160px;
  }
  body .en-container {
    .banner-section {
      ::v-deep() {
        .text2 {
          span {
            font-size: 70px;
          }
        }
      }
    }
  }
}
</style>
